import { render, staticRenderFns } from "./VideoImageUploader.component.vue?vue&type=template&id=31545961&scoped=true"
import script from "./VideoImageUploader.component.vue?vue&type=script&lang=js"
export * from "./VideoImageUploader.component.vue?vue&type=script&lang=js"
import style0 from "./VideoImageUploader.component.vue?vue&type=style&index=0&id=31545961&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31545961",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
